export enum Types {
  NONE = 'none',
  OKTA_SAML = 'Okta',
  ONE_LOGIN_SAML = 'OneLogin',
  AZURE_SAML = 'Azure',
}

export enum SyncStates {
  NotSetup = 'not_setup',
  Running = 'running',
  Completed = 'completed',
  Failed = 'failed',
}

export type StepState = {
  name: string | null;
  department: string | null;
  completedAt: Date | null;
};

export interface Status {
  dataIntegration: Types;
  inviteNew: boolean;
  syncState: {
    state: SyncStates;
    completedAt: Date | null;
    startedAt: Date | null;
  };
  subscribeStatus: {
    subscribe: StepState;
    auth: StepState;
    consent: StepState;
  };
}
